import {TiersResponse} from "@irati/types"

export function getCurrentTier(tiers: TiersResponse[], amount: number): TiersResponse | null {
  return tiers.find(({startValue, endValue}) => (endValue === -1 ? true : amount >= startValue && amount <= endValue)) || null
}

const frequencies = {
  month: 12,
  quarter: 4,
  year: 1
} as const

export type Frequency = keyof typeof frequencies

export const isFrequency = (val: unknown): val is Frequency => typeof val === "string" && Object.keys(frequencies).includes(val)

export function getPotentialSubscriptionSaving(
  tiers: TiersResponse[],
  amount: number,
  paymentRate: Frequency = "month"
): {potentialSaving: number; currentTier: TiersResponse | null; subscriptionTier: TiersResponse | null; projectedAmount: number} {
  const currentTier = getCurrentTier(tiers, amount)
  const projectedAmount = amount * frequencies[paymentRate]
  const subscriptionTier = getCurrentTier(tiers, projectedAmount)

  const potentialSaving =
    projectedAmount * (currentTier?.tierServiceFeeRate ?? 1) - projectedAmount * (subscriptionTier?.tierServiceFeeRate ?? 1)
  return {
    potentialSaving,
    projectedAmount,
    currentTier,
    subscriptionTier
  }
}
